//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  viewCartShop,
  validateDiscountPromotion,
  validateUserLimit,
  discountAppointment
} from "@/api/goodDetails"
import {
  getCookie
} from "@/utils/auth.js";
export default {
  name: 'appointGood',

  data() {
    return {
      cartNum: 0,
      isOnGoing: false,
      haveAppointment: false,
      isInfo:"",//预约提示信息
      buyLimit: null,
      isAppointment: false,
      isPreview: false,
      validate: null, // 101 购买次数已达上限
    }
  },
  computed: {

  },
  props: {
    goodInfo: {
      type: Object,
      value: null,
    },
    goods: {
      type: Object,
      value: null,
    },
    staticDomain: {
      type: String,
      value: "",
    },
    cIsNew:{
      type: Number,
      value: -1,
    },
    dtimes:{
      type:Array,
      value:[]
    },
    minLadderPrice: {
      type: Object,
      value: null,
    },
    gid:{
      type: String,
      value: "",
    },
    startDate:{
      type: Number,
      value: 0,
    },
    nowDate:{
      type: Number,
      value: 0,
    },
    manystockBalance:{
      type: Boolean,
      value: false,
    }

  },
  methods: {
    strLengthFun: function(str) {
      if (str != undefined) {
        let num = str.length;
        return num;
      }
      return 0;
    },
    //获取购物车数量
    getViewCartShopNumFun: function() {
      let uid = getCookie("hdu");
      let hdt = getCookie("hdt");
      let that = this;
      if (!!!uid || !!!hdt) {
        console.info("未登录状态,不查询购物车数量");
      } else {
        viewCartShop().then(res => {
          if (res.code == 1 && res.data > 0) {
            that.cartNum = res.data;
            that.$forceUpdate();
          }
        })
      }
    },
    //跳转到首页
    gotoIndexFun: function() {
      window.location.href = window.location.protocol + "//" + window.location.host;
    },

    //跳转到购物车
    gotoCartFun: function() {
      let uid = getCookie("hdu");
      let hdt = getCookie("hdt");
      let that = this;
      if (!!!uid || !!!hdt) {
        console.info("未登录状态,不查询购物车数量");
      } else {
        window.location.href = window.location.protocol + "//" + window.location.host + "/shoppingCart";
      }

    },
    //立即购买
    buyNow: function(type, status, gbid, gift) {
      this.$emit("buyNow", type, status, gbid,gift)
    },

    //获取预约状态
    getValidateDiscountPromotion: function() {
      let that = this;
      validateDiscountPromotion(this.goodInfo.discountPromId,this.gid).then(res => {
        if (res.code == 1) {
          if(!res.data.status){
            that.isInfo =  res.data.info;
          }else{
            that.isInfo =  "";
          }
          that.isOnGoing = res.data.isOnGoing;
          that.haveAppointment = res.data.haveAppointment;
          that.buyLimit = res.data.buyLimit;

          that.isAppointment = res.data.isAppointment;
          that.isPreview = res.data.isPreview;

          console.log("状态---------------")

          //如果是已预约  开始进行活动时间倒计时
          if(that.haveAppointment){
            let n = that.nowDate;
            let going = setInterval(function(){
              n = n + 1000;
              if(n >= that.startDate){
                that.isOnGoing = true;
                console.log("n==============",n)
                clearInterval(going)
              }
            },1000)
          }


          this.$forceUpdate();
        }
      })

    },

    //购买次数已达上限
    getValidateUserLimit: function() {
      let that = this;
      let params = {
        gbpId: that.goodInfo.gbpId,
      }
      validateUserLimit(that.goodInfo.gbpId).then(res => {
        if (res.status) {
          that.validate = res.status;
        }
      })
    },
  },
  created() {
    this.getViewCartShopNumFun(); //获取购物车数量
  },
  mounted() {

  },
  watch: {
    goodInfo() {
      console.log("这里---------------")
      //获取预约状态
      if (this.goodInfo.discountPromId) {
        this.getValidateDiscountPromotion()
      }

      //获取购买次数已达上限
      if(this.goodInfo.gbpId){
        this.getValidateUserLimit();
      }
    },
    cartNum: {
        handler(newValue) {
        	this.cartNum = newValue
        },
        immediate: true
    }


  }
}



// WEBPACK FOOTER //
// ./src/components/goodDetail/footerBtns.vue